<template>
  <v-dialog width="500px" v-model="viewMenu">
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>
        <v-layout row wrap v-if="lastfall">
             <v-flex xs3>
                <v-subheader v-text="'Lastfallname:'"></v-subheader>   
            </v-flex>
            <v-flex xs9>
                <v-text-field label="Lastfallname" type="text" v-model.number="lastfall.name" required></v-text-field>
            </v-flex>           
            <v-flex xs3>
                <v-subheader v-text="'Farbe:'"></v-subheader>   
            </v-flex>
            <v-flex xs9>
                <v-btn small :color="lastfall.Color"  @click="colorPicker(lastfall)"></v-btn>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import Lastfall from '../../js/Lastfall.js'
/* eslint-disable */
export default {
    data(){
        return{
            lastfall: new Lastfall,
            showColorPicker: false,
        }
    },
    computed: {
        lastfallliste() { return this.$store.state.StatikSystem.Lastfallliste },
        title() { return 'neuer Lastfall'},
        viewMenu: {
            get() { return this.$store.getters.vLastfallMenu },   
            set(value) { this.$store.commit('setvLastfallMenu', value)} 
        },
    },
    methods: {
        colorPicker(lastfall){
            // this.$refs.ColorPicker.click()
            this.$store.state.cLastfall = lastfall
            this.$store.commit('setvColorPicker', true)
        },
        onColorPicked(e){
            this.lastfall.Color = e.target.value
        },
        apply(){
            this.$store.commit('LastfallDialogApply', this.lastfall)
            this.viewMenu = false
            this.lastfall = undefined
        },
        cancel(){
            this.viewMenu = false
            this.lastfall = undefined
        },
    },
    beforeUpdate(){
        if (!this.lastfall && this.viewMenu) {
            this.lastfall = new LastfallClass(null, 'neuer Lastfall', '#aaaaaa')
        } 
    }
}
</script>
